import React, { useState, useContext, useEffect, forwardRef } from "react";

import {
  Grid,
  Card,
  Link,
  Divider,
  Typography,
  Breadcrumbs,
  TextField,
  IconButton,
  FormControlLabel,
  Checkbox,
  List,
} from "@material-ui/core";

import { Alert, AlertTitle } from "@material-ui/lab";
import { alpha } from "@material-ui/core/styles/colorManipulator";

import { makeStyles } from "@material-ui/core/styles";

import Spinner from "../layout/Spinner";

import FulfillmentContext from "../../context/fulfillment/FulfillmentContext";
import FulfillmentTable from "./FulfillmentTable";
import FulfillmentFilter from "./FulfillmentFilter";

const FulfillmentHome = () => {
  const fulfillmentContext = useContext(FulfillmentContext);
  const { getUnfulfill, loading } = fulfillmentContext;
  const [dateIndex, setDateIndex] = useState("");
  const [rows, setRows] = useState([]);
  const [fileName, setFileName] = useState("");
  const [dateRange, setDateRange] = useState("");
  const [state, setState] = useState({
    order_id: "",
    error_message: "",
    success_message: "",
  });

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    errorAlert: {
      width: "40%",
      "& > * + *": {
        marginTop: theme.spacing(5),
      },
      position: "absolute",
    },
    errorAlertColor: {
      backgroundColor: alpha("#ffc2b3", 0.7),
    },
    successAlert: {
      width: "40%",
      "& > * + *": {
        marginTop: theme.spacing(5),
      },
      position: "absolute",
    },
    successAlertColor: {
      backgroundColor: alpha("#e6ffcc", 0.7),
    },
  }));

  const classes = useStyles();

  const dateYYMMDD = (ISO) => {
    let ISO_split = ISO.split("T");
    let date_split = ISO_split[0].split("-");
    let year = parseInt(date_split[0]) - 2000;
    return year + date_split[1] + date_split[2];
  };

  //On load get Today Data
  useEffect(() => {
    const from = new Date(new Date().setHours(8, 0, 0, 0)).toISOString();
    const to = new Date(new Date().setHours(32, 0, 0, 0)).toISOString();
    getUnfulfill(from, to);
    setDateIndex(from + " " + to);
    setFileName("fulfillment_" + dateYYMMDD(from) + "_" + dateYYMMDD(from));
    const fromDisplay = from.split("T");
    const toDisplay = from.split("T");
    setDateRange("Records from " + fromDisplay[0] + " to " + toDisplay[0]);
  }, []);

  // Table column
  const column = [
    {
      field: "store_name",
      title: "Store Name",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "order_id",
      title: "Order ID",
      cellStyle: {
        width: 100,
        maxWidth: 100,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "sku",
      title: "SKU",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "quantity",
      title: "Quantity",
      cellStyle: {
        width: 50,
        maxWidth: 50,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "total_quantity",
      title: "Total Quantity",
      cellStyle: {
        width: 50,
        maxWidth: 50,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "amount",
      title: "Amount",
      cellStyle: {
        width: 50,
        maxWidth: 50,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "product_name",
      title: "Product Name",
      cellStyle: {
        width: 300,
        minWidth: 300,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "variant_title",
      title: "Variant Title",
      cellStyle: {
        width: 300,
        minWidth: 300,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "name",
      title: "Name",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "address",
      title: "Address",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "city",
      title: "City",
      cellStyle: {
        width: 100,
        maxWidth: 100,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "province",
      title: "Province",
      cellStyle: {
        width: 100,
        maxWidth: 100,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "country",
      title: "Country",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "zip",
      title: "Zip",
      cellStyle: {
        width: 100,
        minWidth: 100,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "phone",
      title: "Phone",
      cellStyle: {
        width: 100,
        minWidth: 100,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "email",
      title: "Email",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "date_ordered",
      title: "Date Ordered",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "shipping_cost",
      title: "Shipping Cost",
      cellStyle: {
        width: 100,
        maxWidth: 100,
        fontSize: 12,
        textAlign: "center",
      },
    },
    {
      field: "product_cost",
      title: "Product Cost",
      cellStyle: {
        width: 100,
        maxWidth: 100,
        fontSize: 12,
        textAlign: "center",
      },
    },
  ];

  const [columnList, setColumnList] = useState(column);

  return (
    <div className={classes.root}>
      <Grid container direction="row" justifyContent="center">
        {" "}
        {state.error_message ? (
          <div className={classes.errorAlert}>
            <Alert severity="error" className={classes.errorAlertColor}>
              {" "}
              <AlertTitle>
                <strong> Alert </strong>{" "}
              </AlertTitle>{" "}
              {state.error_message}{" "}
            </Alert>{" "}
          </div>
        ) : null}{" "}
        {state.success_message ? (
          <div className={classes.successAlert}>
            <Alert severity="success" className={classes.successAlertColor}>
              {" "}
              <AlertTitle>
                <strong> Success </strong>{" "}
              </AlertTitle>{" "}
              {state.success_message}{" "}
            </Alert>{" "}
          </div>
        ) : null}{" "}
      </Grid>{" "}
      <Grid container direction="row" spacing={1}>
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Fulfillment </Typography>{" "}
          </Grid>{" "}
        </Grid>{" "}
        <Grid item xs={12}>
          <Card>
            <Grid container direction="row">
              <Grid item xs={12}>
                <FulfillmentFilter
                  dateIndex={dateIndex}
                  setDateIndex={setDateIndex}
                  rows={rows}
                  fileName={fileName}
                  setFileName={setFileName}
                  setDateRange={setDateRange}
                  column={column}
                  setColumnList={setColumnList}
                  state={state}
                  setState={setState}
                />{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Divider variant="fullWidth" />
              </Grid>{" "}
              {loading ? (
                <Grid
                  container
                  direction="column"
                  justifyContent="flex-end"
                  style={{
                    height: 300,
                  }}
                >
                  <Spinner />
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <FulfillmentTable
                    rows={rows}
                    setRows={setRows}
                    dateRange={dateRange}
                    columnList={columnList}
                  />{" "}
                </Grid>
              )}{" "}
            </Grid>{" "}
          </Card>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </div>
  );
};

export default FulfillmentHome;
